export default "__VITE_ASSET__DjoA2u54__"